import { z as zod } from 'zod';
import { MediaRefSchema } from "@/app/features/shared/__to_be_integrated/types/forms/MediaRefSchema";
import { LinkSchema } from "@/app/features/shared/__to_be_integrated/types/forms/LinkSchema";

export const HomeTileSchema = zod.object({
    id: zod.string(),
    label: zod.string(),
    order: zod.number(),
    image: MediaRefSchema,
    route: LinkSchema
});

export const SiteHomeSchema = zod.object({
    title: zod.string(),
    intro: zod.string().nullish(),
    image: MediaRefSchema,
    tiles: zod.array(HomeTileSchema)
});

export type SiteHomeEditable = zod.infer<typeof SiteHomeSchema>;
export type HomeTileEditable = zod.infer<typeof HomeTileSchema>;